import React from "react";
import type { Attachment, DigiFiCustomer } from "src/types/conditionsInbox";
import { CustomerCardItem } from "./CustomerCardItem";
import { PlaceholderText } from "./SearchSection.styles";

interface CustomerResultsSectionProps {
  attachments: Attachment[];
  renamedAttachments?: Record<string, string>;
  searchResults: DigiFiCustomer[];
  expandedCard: string | null;
  sentToCustomers: Set<string>;
  isSendingFiles: boolean;
  onToggleCard: (customer: DigiFiCustomer) => void;
  onSendFiles: (customer: DigiFiCustomer, attachmentsId: Set<string>) => void;
  selectedEmailId: string | null;
  searchTerm: string;
}

export const CustomerResultsSection: React.FC<CustomerResultsSectionProps> = ({
  attachments,
  renamedAttachments,
  searchResults,
  expandedCard,
  sentToCustomers,
  isSendingFiles,
  onToggleCard,
  onSendFiles,
  selectedEmailId,
  searchTerm,
}) => {
  if (searchResults.length === 0 && searchTerm) {
    return (
      <PlaceholderText>
        No customers found matching "{searchTerm}"
      </PlaceholderText>
    );
  }

  return (
    <div>
      {searchResults.map((customer) => {
        const isSent = sentToCustomers.has(customer.id);
        const isCurrentlySending = isSendingFiles && !isSent;

        return (
          <CustomerCardItem
            key={customer.id}
            attachments={attachments}
            renamedAttachments={renamedAttachments}
            customer={customer}
            expandedCard={expandedCard}
            isSent={isSent}
            isCurrentlySending={isCurrentlySending}
            onToggleCard={onToggleCard}
            onSendFiles={onSendFiles}
            selectedEmailId={selectedEmailId}
          />
        );
      })}
    </div>
  );
};
